import Vue from 'vue';

import InputVue from './Input.vue';
import SelectVue from './Select.vue';

export default function inputComponent(_Vue: typeof Vue) {
  _Vue.component('AppInput', InputVue);
  _Vue.component('AppSelect', SelectVue);
}
